
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 255.68 255.69"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Layer 1"}},[_c('path',{attrs:{"d":"M127.84 0a127.85 127.85 0 10127.84 127.84A128 128 0 00127.84 0z","fill":"#1e1e1e"}}),_c('path',{attrs:{"d":"M130.15 62.67l-58.73 32-.72.39v65.68l58.79 31.36.65.35 58.7-31.32.74-.39V95.45zm0 15.2L169 99.31 130.17 120 91.52 98.93zm6.69 95.95v-42.24l39.45-21.05v42.24zm-13.33-42.28v42.28L84 152.78V110z","fill":"#fff"}})])])])
          )
        }
      }
    